export default "__VITE_ASSET__DhO3RH6U__"